"use client";

import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon } from "lucide-react";
import classNames from "components/ui/classNames";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={classNames(
      "pointer-events-auto box-border inline-flex h-[18px] w-[18px] cursor-pointer",
      "items-center justify-center rounded-md border border-gray-400 bg-white",
      "disabled:pointer-events-none disabled:bg-gray-100",
      "dark:border-transparent dark:bg-slate-950 dark:text-slate-300",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={classNames("flex items-center justify-center text-current")}>
      <CheckIcon className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
